/** snake_case / kebab-case / camelCase value -> "Title Case" label fallback.
 * Null/undefined-safe: returns "" for a missing value so a nullable enum/label
 * field never crashes a renderer. Call sites decide their own "—" fallback. */
export function humanizeLabel(value: string | null | undefined): string {
  if (value == null) return ''
  return value
    .replace(/[_-]+/g, ' ')
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase())
}
